module.exports = __webpack_public_path__ + "img/Metamask.516063e9.png";